<script>
import { markRaw } from 'vue';

import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'

import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

import ReservationTab from './Part/ReservationTab.vue';
import RoomTab from './Part/RoomTab.vue';
import EmployeeTab from './Part/EmployeeTab.vue';
import ConfigTab from './Part/ConfigTab.vue';

import OpenHourFormSidebar from './Part/OpenHourFormSidebar.vue';
import SpecialDayFormSidebar from './Part/SpecialDayFormSidebar.vue';

export default {
    components: {
        Layout,
        PageHeader,

        FullCalendar,

        ReservationTab,
        RoomTab,
        EmployeeTab,
        ConfigTab
    },
    data() {
        var vm = this;

        return {
            openHourFormSidebar: markRaw(OpenHourFormSidebar),
            specialDayFormSidebar: markRaw(SpecialDayFormSidebar),

            data: {},
            tabIndex: 0,
            open_hour: [],
            calendarOptions: {
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: 'dayGridMonth',
                showNonCurrentDates: false,
                fixedWeekCount: false,
                buttonText: {
                    today: vm.$t('basic.calendar.today'),
                },
                events: this.onLoadCalendar,
                // eventClick: this.onClickEvent,
                // eventMouseEnter: this.onEnterEvent,
                eventClick: this.onEnterEvent,
                eventDidMount(info) {
                    const popover = new bootstrap.Popover(info.el, {
                        content: `
<div>
    <div class="fw-semibold">
        ${info.event.title}
    </div>
    <div class="text-muted mt-1">
        ${info.event.extendedProps.model.notes ?? '-'}
    </div>
</div>
`,
                        placement: 'top',
                        trigger: 'manual',
                        container: 'body',
                        html: true,
                        customClass: 'fc-popover-small'
                    })

                    info.el._popover = popover
                }
            }
        };
    },
    created() {
        var vm = this;

        vm.syncTabFromRoute();
    },
    mounted() {
        var vm = this;

        document.addEventListener('click', (e) => {
            document.querySelectorAll('.fc-event').forEach(el => {
                if (el._popover && !el.contains(e.target)) {
                    el._popover.hide()
                }
            })
        })

        vm.load();
    },
    beforeUnmount() {
        document.querySelectorAll('.fc-event').forEach(el => {
            if (el._popover) {
                el._popover.dispose()
                el._popover = null
            }
        })
    },
    watch: {
        tabIndex(newVal) {
            this.updateTabQuery(newVal);
        }
    },
    methods: {
        syncTabFromRoute() {
            var index = this.$route.query.tabIndex;

            if (index !== undefined) {
                this.tabIndex = Number(index);
            }
        },
        updateTabQuery(index) {
            const current = Number(this.$route.query.tabIndex);

            if (current !== index) {
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        tabIndex: index
                    }
                });
            }
        },
        load() {
            var vm = this;

            vm.create();
            vm.loadOpenHour();
        },
        newData() {
            var vm = this;

            var data = {
                id: null,
                ref_no: null,
                name: null,
                store: null,
                store_ref_no: null,
                address: null,
                is_open: null
            };

            vm.data = Object.assign({}, data);
        },
        async create() {
            var vm = this;

            this.$loading.on('branch_detail_create');
            try {
                vm.newData();

                var resp = await this.$api.Branch.get(vm.$route.params.id);
                var data = resp.data.data;

                vm.data = data;

                this.$loading.off('branch_detail_create');
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
        },
        async loadOpenHour() {
            var vm = this;

            this.$loading.on('branch_detail_open_hour_create');

            try {
                var params = {
                    page: 'all',
                    branch_id: vm.$route.params.id
                };

                var resp = await vm.$api.OpenHour.all(params);

                var data = resp.data.data;
                vm.open_hour = data;

                vm.$loading.off('branch_detail_open_hour_create');
            } catch (err) {
                // console.log(err.response.data.message) 
            }
        },
        onUpdateBranch() {
            var vm = this;

            vm.create();
        },
        onDeleteBranch() {
            var vm = this;

            vm.$router.back();
        },
        onEnterEvent(info) {
            document.querySelectorAll('.fc-event').forEach(el => {
                if (el._popover) el._popover.hide()
            })

            info.el._popover.toggle()
        },
        async onLoadCalendar(info) {
            var vm = this;

            var params = {
                page: 'all',
                date_from: vm.$dateFormat.strToDate(info.startStr),
                date_to: vm.$dateFormat.strToDate(info.endStr),
                branch_id: vm.$route.params.id
            };

            var resp = await vm.$api.SpecialDay.all(params);

            var data = resp.data.data;

            data = vm.$_.map(data, function (x) {
                return {
                    title: [x.open_at, x.closed_at].join(" - "),
                    start: x.date,
                    allDay: true,
                    color: "#299cdb",
                    editable: false,
                    extendedProps: {
                        model: x
                    }
                };
            });

            return data;
        },
        onRefreshOpenHour() {
            var vm = this;

            vm.loadOpenHour();
        },
        onRefreshSpecialDay() {
            var vm = this;

            const calendarApi = vm.$refs.calendarRef.getApi();
            calendarApi.refetchEvents();
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('branch.title.detail')" :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow>
            <BCol lg="12">
                <BCard no-body class="mt-n4 mx-n4 ribbon-box right">
                    <div :class="{
                        'bg-danger-subtle': data.is_open == 0,
                        'bg-success-subtle': data.is_open == 1,
                    }">
                        <BCardBody class="pb-0 px-4">
                            <div v-if="data.is_open == 1" class="ribbon-three ribbon-three-success"><span>{{
                                $t('branch.status.open') }}</span></div>
                            <div v-if="data.is_open == 0" class="ribbon-three ribbon-three-danger"><span>{{
                                $t('branch.status.closed') }}</span></div>
                            <BRow class="mb-3">
                                <BCol md>
                                    <BRow class="align-items-center g-3">
                                        <BCol md="auto">
                                            <!-- <div class="avatar-lg">
                                                <div class="avatar-title bg-white rounded-circle">
                                                    <img src="@/assets/images/cafeman/store.svg" alt=""
                                                        class="avatar-md">
                                                </div>
                                            </div> -->
                                            <div class="d-flex justify-content-center mb-3 mt-3">
                                                <div class="avatar-lg">
                                                    <div class="avatar-title text-light rounded-circle d-flex align-items-center justify-content-center"
                                                        :class="{ 'bg-danger': data.is_open == 0, 'bg-success': data.is_open == 1 }">
                                                        <i class="mdi mdi-map-marker" style="font-size: 50px;"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </BCol>
                                        <BCol md>
                                            <skeleton :loading="$loading.get('branch_detail_create')"
                                                :schema="['col-1', 'col-2']">
                                                <h4 class="fw-bold mb-0">{{ data.name }}</h4>
                                                <h6 class="text-body-secondary">{{ data.ref_no }}</h6>
                                            </skeleton>
                                            <skeleton :loading="$loading.get('branch_detail_create')"
                                                :schema="['col-1', 'col-2']">
                                                <div class="d-flex align-items-center">
                                                    <i class="mdi mdi-store-outline me-2 fs-4"></i>
                                                    <div class="d-flex flex-column">
                                                        <span>{{ data.store_ref_no }} | {{ data.store }}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="mdi mdi-map-marker fs-4 me-2"></i>
                                                    <div class="d-flex flex-column">
                                                        <span>{{ data.address }}</span>
                                                    </div>
                                                </div>
                                            </skeleton>
                                        </BCol>
                                    </BRow>
                                </BCol>
                            </BRow>
                        </BCardBody>
                    </div>
                </BCard>
            </BCol>
        </BRow>

        <BRow>
            <BCol lg="8">
                <BTabs nav-class="nav-primary mb-3" pills lazy v-model="tabIndex">
                    <hr class="border-dashed">
                    <BTab :title="$t('branch.tab.reservation')" class="pt-2"
                        v-if="$ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_list') && ($ac.hasAccessStore(data.store_id) || $ac.hasAccessBranch(data.id)))">
                        <ReservationTab :branch="data" />
                    </BTab>
                    <BTab :title="$t('branch.tab.room')" class="pt-2"
                        v-if="$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_list') && ($ac.hasAccessStore(data.store_id) || $ac.hasAccessBranch(data.id)))">
                        <RoomTab :branch="data" />
                    </BTab>
                    <BTab :title="$t('branch.tab.employee')" class="pt-2"
                        v-if="$ac.hasAccess('employee_full_access') || ($ac.hasAccess('employee_list') && $ac.hasAccessStore(data.store_id))">
                        <EmployeeTab :branch="data" />
                    </BTab>
                    <BTab :title="$t('branch.tab.config')" class="pt-2"
                        v-if="$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_create') && $ac.hasAccessStore(data.store_id))">
                        <ConfigTab @onUpdate="onUpdateBranch" @onDelete="onDeleteBranch" :branch="data" />
                    </BTab>
                </BTabs>
            </BCol>
            <BCol lg="4">
                <BRow>
                    <BCol>
                        <BCard no-body class="mb-3"
                            v-if="$ac.hasAccess('open_hour_full_access') || ($ac.hasAccess('open_hour_list') && ($ac.hasAccessStore(data.store_id) || $ac.hasAccessBranch(data.id)))">
                            <BCardBody>
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <div>
                                        <h5 class="mb-0">{{ $t('branch.label.open_hours') }}</h5>
                                        <p class="text-muted mb-0">{{ $t('branch.notes.open_hours') }}</p>
                                    </div>
                                </div>
                                <loading :loading="$loading.get('branch_detail_open_hour_create')" variant="dark"
                                    type="block">
                                    <simplebar data-simplebar style="max-height: 300px;">
                                        <div class="table-responsive">
                                            <BListGroup tag="ul" class="mb-1">
                                                <BListGroupItem tag="li" v-for="(tr, index) in open_hour" :key="index">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <span class="fw-medium">{{ tr.day }}</span>
                                                        <BBadge class="bg-info shadow-none fs-6">
                                                            {{ tr.open_at }} - {{ tr.closed_at }}
                                                        </BBadge>
                                                    </div>
                                                </BListGroupItem>
                                            </BListGroup>
                                        </div>
                                    </simplebar>
                                    <div class="text-center mt-3"
                                        v-if="$ac.hasAccess('open_hour_full_access') || ($ac.hasAccess('open_hour_list') && ($ac.hasAccessStore(data.store_id) || $ac.hasAccessBranch(data.id)))">
                                        <router-link
                                            :to="{ name: 'open-hour', query: { store_id: data.store_id, branch_id: $route.params.id } }">{{
                                                $t('basic.btn.more') }}</router-link>
                                    </div>
                                </loading>
                            </BCardBody>
                            <BCardFooter
                                v-if="$ac.hasAccess('open_hour_full_access') || ($ac.hasAccess('open_hour_create') && $ac.hasAccessStore(data.store_id))">
                                <btn-sidebar variant="success" customClass="w-100 mb-2"
                                    :sidebar="openHourFormSidebar" :data="{ branch: data }"
                                    :success="onRefreshOpenHour">
                                    <i class="mdi mdi-plus-thick me-1"></i>
                                    {{ $t('basic.btn.add') }}
                                </btn-sidebar>
                            </BCardFooter>
                        </BCard>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BCard no-body class="mb-3"
                            v-if="$ac.hasAccess('special_day_full_access') || ($ac.hasAccess('special_day_list') && ($ac.hasAccessStore(data.store_id) || $ac.hasAccessBranch(data.id)))">
                            <BCardBody>
                                <div class="d-flex mb-4">
                                    <h6 class="card-title mb-0 flex-grow-1">{{ $t('branch.label.special_day') }}</h6>
                                </div>
                                <FullCalendar :options="calendarOptions" ref="calendarRef" />
                                <div class="text-center mt-3"
                                    v-if="$ac.hasAccess('special_day_full_access') || ($ac.hasAccess('special_day_list') && ($ac.hasAccessStore(data.store_id) || $ac.hasAccessBranch(data.id)))">
                                    <router-link
                                        :to="{ name: 'special-day', query: { store_id: data.store_id, branch_id: $route.params.id } }">{{
                                            $t('basic.btn.more') }}</router-link>
                                </div>
                            </BCardBody>
                            <BCardFooter
                                v-if="$ac.hasAccess('special_day_full_access') || ($ac.hasAccess('special_day_create') && $ac.hasAccessStore(data.store_id))">
                                <btn-sidebar variant="success" customClass="w-100 mb-2"
                                    :sidebar="specialDayFormSidebar" :data="{ branch: data }"
                                    :success="onRefreshSpecialDay">
                                    <i class="mdi mdi-plus-thick me-1"></i>
                                    {{ $t('basic.btn.add') }}
                                </btn-sidebar>
                            </BCardFooter>
                        </BCard>
                    </BCol>
                </BRow>
            </BCol>
        </BRow>
    </Layout>
</template>

<style scoped>
:deep(.fc-event) {
    cursor: pointer;
}
</style>

<style>
.fc-daygrid-event {
    max-height: 20px;
    padding: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
}

.fc-daygrid-event .fc-event-title {
    font-size: 10px;
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fc-popover-small .popover-body {
    padding: 4px 8px;
    font-size: 12px;
    line-height: 1.2;
}

.fc-popover-small .popover-header {
    padding: 4px 8px;
    font-size: 12px;
}
</style>